import { Checkbox, Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import CircularLoading from "../../commons/loading/CircularLoading";
import { tableConfig } from "../../commons/table/tableConfig";

const SiniestroTable = ({
  searchedSiniestro,
  handleSubmit,
  selectedSiniestro,
}) => {

  const columns = useMemo(() => [
    {
      id: 'selected',
      header: '',
      size: 50,
      Cell: ({ row }) => (
        <Checkbox
          checked={
            row.original.numeroSiniestroART ===
            selectedSiniestro?.numeroSiniestroART
          }
          onChange={() => {
            handleSubmit(row.original);
          }}
        />
      )
    },
    {
      accessorKey: 'numeroSiniestroART',
      header: 'Nro. Siniestro',
    },
    {
      accessorKey: 'numeroDocumento',
      header: 'Nro. Documento',
    },
    {
      accessorKey: 'apellidoNombres',
      header: 'Apellido, Nombre',
    },
  ], [handleSubmit, selectedSiniestro]);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: searchedSiniestro.data || [],
    state: {
      isLoading: searchedSiniestro.loading,
    },
    renderEmptyRowsFallback: () => (
      <div style={{ padding: "40px 0", textAlign: "center" }}>
        {searchedSiniestro.loading ? (
          <CircularLoading />
        ) : (
          <Typography variant="body1" color="textSecondary">
            No se ha encontrado resultado con los datos ingresados, por favor comunicarse con la ART
          </Typography>
        )}
      </div>
    ),
    enablePagination: true,
    enableSorting: false,
    enableTopToolbar: false,
    paginationDisplayMode: 'pages',
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : to}`,
    },
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
      density: 'compact',
    },
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No hay datos para mostrar",
    },
    muiTablePaperProps: {
      elevation: 1,
    },
  });

  return (
    <MaterialReactTable table={table} />
  );
};

export default SiniestroTable;